<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
      <el-popconfirm
        confirm-button-text="确定"
        cancel-button-text="取消"
        icon="el-icon-info"
        icon-color="red"
        title="确认离线导出么？"
        @confirm="rsyncExport"
      >
        <el-button slot="reference" v-if="hasPermsExport"><i class="el-icon-upload2" />离线导出</el-button>
      </el-popconfirm>
      <button-link :to="`downloads`" v-if="hasPermsDownloads"><i class="el-icon-download" />下载中心</button-link>
    </el-button-group>

    <el-table :data="advanceRecharges" resource="advance-recharges" v-loading="loading">
      <el-table-column prop="recharge_id" label="充值编号" width="190" />

      <el-table-column align="center" header-align="center" label="账户" width="190">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_info.level_name }})</span>
            <br>
            <span>{{ scope.row.user.mobile }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="amount" label="充值金额" width="100" />

      <el-table-column label="支付信息" width="200">
        <template slot-scope="scope">
          {{ scope.row.pay_status_text }}
          <br>
          <span>{{ scope.row.pay_order_no }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" header-align="center" label="状态" width="180">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.check_status === 0" type="warning" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.check_status === 1" type="success" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <el-tag v-if="scope.row.check_status === 2" type="danger" disable-transitions>{{ scope.row.status_text }}</el-tag>
          <br>
          <span>
            {{ scope.row.op_name }}
            <br>
            {{ scope.row.check_time }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="支付凭证" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.voucher">
            <el-image :src="scope.row.voucher" :preview-src-list="[scope.row.voucher]">
              <div slot="error" class="image-slot"><i class="el-icon-picture-outline" /></div>
            </el-image>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="memo" label="用户留言" />
      <el-table-column prop="created_at" label="充值时间" width="170" />

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button-group>
            <el-button
              v-if="scope.row.check_status === 0 && scope.row.pay_status == 0 && hasPermsChangeAdviceStatus"
              @click="onChangeAdviceStatus(scope.$index, scope.row)"
              size="small"
            >审核</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>

    <el-dialog title="充值审核" :visible.sync="setAdviceStatusDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="form"
        :submit="onAdviceStatusSubmit"
        :errors.sync="errors"
        :form.sync="form"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="结果" prop="check_status" required>
          <el-select v-model="form.check_status" placeholder="请选择">
            <el-option label="审核通过" value="1" />
            <el-option label="审核失败" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="check_remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" v-model="form.check_remark" show-word-limit maxlength="300" />
        </el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getAdvanceRecharges, changeAdviceStatus, exportAdvanceRecharge } from '@/api/advance-recharges'
import { getFirstError, can } from '@/libs/utils'
import LzForm from '@c/LzForm'
import { Loading } from 'element-ui'
import { downFile } from '@/libs/download-helper'

import ButtonLink from '@c/ButtonLink'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
    LzForm,
    ButtonLink,
  },
  data() {
    return {
      search: [
        {
          field: 'recharge_id',
          label: '充值编号',
        },
        {
          field: 'keyword',
          label: '手机/姓名',
        },
        {
          field: 'idcard_no',
          label: '身份证',
        },
        {
          field: 'auth_code',
          label: '授权码',
        },
        {
          field: 'pay_status',
          label: '支付类型',
          type: 'el-select',
          options: [
            // { id: 0, name: '线下支付' },
            { id: 1, name: '微信支付' },
          ],
          labelField: 'name',
          valueField: 'id',
        },
        {
          field: 'check_status',
          label: '审核状态',
          type: 'el-select',
          options: [
            { id: 0, name: '申请中' },
            { id: 1, name: '充值成功' },
            { id: 2, name: '审核失败' },
          ],
          labelField: 'name',
          valueField: 'id',
        },
        {
          field: 'created_at',
          label: '创建时间',
          type: 'el-date-picker',
        },
      ],
      advanceRecharges: [],
      page: null,
      loading: true,
      setAdviceStatusDialog: false,
      errors: {},
      form: {
        id: 0,
        check_status: '1',
        check_remark: '',
      },
      query: {},
      hasPermsChangeAdviceStatus: false,
      hasPermsExport: false,
      hasPermsDownloads: false,
    }
  },
  created() {
    this.hasPermsChangeAdviceStatus = can('advance-recharges.change-advice-status')
    this.hasPermsExport = can('advance-recharges.export')
    this.hasPermsDownloads = can('downloads')
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        this.loadData(newVal.query)
      },
      immediate: true,
    },
  },
  methods: {
    async loadData(newVal) {
      const {
        data: { data, meta },
      } = await getAdvanceRecharges(newVal)
      this.advanceRecharges = data
      this.page = meta
      this.loading = false
    },
    async rsyncExport() {
      try {
        await exportAdvanceRecharge(this.query)
        this.$message.success('离线下载中...')
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    async onChangeAdviceStatus(index, row) {
      this.setAdviceStatusDialog = true
      this.form.id = row.id
    },
    async onAdviceStatusSubmit() {
      try {
        const { data } = await changeAdviceStatus(this.form)
        this.setAdviceStatusDialog = false
        this.$message.success(data)
        this.clearForm()
        await this.loadData({})
      } catch (e) {
        console.log(e)
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    clearForm() {
      this.form = {
        id: 0,
        check_status: '1',
        check_remark: '',
      }
    },
    async jumpExport() {
      const loadingInstance = Loading.service({ target: document.querySelector('.loading-area'), text: '下载中...' })
      const { data } = await exportAdvanceRecharge(this.query).setConfig({ responseType: 'blob' })
      var blob = new Blob([data], { type: 'application/vnd.ms-excel' })
      downFile(blob, 'advance-recharge.xlsx')
      this.$nextTick(() => {
        // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close()
      })
    },
  },
}
</script>
